export function isEmpty(value: unknown): boolean {
    return typeof value === 'undefined' || value === null || value === '' || (Array.isArray(value) && value.length === 0);
}
